/**
 * Controller: SelectCouponsModal
 */
angular.module('acme.view.application.coupons.categories.create.selectCouponsModal.controllers', [])
.controller('SelectCouponsModalController', [ '$scope', '$filter', '$uibModalInstance', 'coupons', function($scope, $filter, $uibModalInstance, coupons) {

    $scope.selectCouponsModal = {
      coupons: [],

      filtered: [],

      searchQuery: '',

      search: function() {
        this.filtered = $filter('filter')(this.coupons, function(coupon) {
          var name = coupon.name || '',
            code = coupon.code || '',
            value = (name + code).toLowerCase();

          return (value.indexOf($scope.selectCouponsModal.searchQuery.toLowerCase()) !== -1) ? coupon : null;
        });
      },

      getSelected: function() {
        var i, ii,
          selectedCoupons = [],
          self = $scope.selectCouponsModal;

        for (i=0,ii=self.coupons.length;i<ii;i++) {
          if (self.coupons[i].selected) {
            //this is so that it doesn't show up as selected next time modal opens
            self.coupons[i].selected = false;
            selectedCoupons.push(self.coupons[i]);
          }
        }

        return selectedCoupons;
      },

      done: function () {
        $scope.selectCouponsModal.success();
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: function () {
        $uibModalInstance.close($scope.selectCouponsModal.getSelected());
      },

      init: function () {
        $scope.selectCouponsModal.coupons = coupons;
        $scope.selectCouponsModal.search();
      }
    };

    $scope.selectCouponsModal.init();
}]);